/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description RangePicker
 */
import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker/generatePicker/interface';

import dateParser from 'lib/dateParser';
import { MONTH_DATE_YEAR_SLASH_FORMAT, YEAR_MONTH_DATE_FORMAT } from '@veritable/common/constants';

/**
 * interface for props
 */
export type IRangePickerProps = Omit<RangePickerProps<IDate>, 'value' | 'onChange'> & {
	value: [string, string] | null;
	onChange: (value: [string, string] | null) => void;
	inputDateFormat?: string;
};

/**
 * Date Picker
 * @param {IRangePickerProps} props props
 * @returns {React.FC} RangePicker
 */
const RangePicker: React.FC<IRangePickerProps> = ({
	value,
	onChange,
	placeholder = ['Start date', 'End date'],
	inputDateFormat = YEAR_MONTH_DATE_FORMAT,
	...restProps
}) => {
	const [start, end] = value || [];
	/**
	 * return RangePicker
	 */
	return (
		<DatePicker.RangePicker
			{...restProps}
			placeholder={placeholder}
			format={MONTH_DATE_YEAR_SLASH_FORMAT}
			value={start && end ? [dateParser(start, inputDateFormat), dateParser(end, inputDateFormat)] : null}
			onChange={(newValue) => {
				if (newValue) {
					onChange([dateParser(newValue[0]).format(inputDateFormat), dateParser(newValue[1]).format(inputDateFormat)]);
				} else {
					onChange(null);
				}
			}}
		/>
	);
};

export default RangePicker;
